import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["onOk", "okText"],
    _excluded2 = ["onOk", "okText", "onCancel", "cancelText"];
import { getOpenMethod, open as maskingOpen } from '../masking/methods';
export function normalizeAlert(config) {
  var _ref = config || {},
      onOk = _ref.onOk,
      okText = _ref.okText,
      restConfig = _objectWithoutPropertiesLoose(_ref, _excluded);

  return _extends({
    footer: [{
      content: okText || function (locale) {
        return locale.Dialog.okText;
      },
      className: 'confirm',
      onClick: onOk
    }]
  }, restConfig);
}
export function normalizeConfirm(config) {
  var _ref2 = config || {},
      onOk = _ref2.onOk,
      okText = _ref2.okText,
      onCancel = _ref2.onCancel,
      cancelText = _ref2.cancelText,
      restConfig = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return _extends({
    footer: [{
      content: cancelText || function (locale) {
        return locale.Dialog.cancelText;
      },
      className: 'cancel',
      onClick: onCancel
    }, {
      content: okText || function (locale) {
        return locale.Dialog.okText;
      },
      className: 'confirm',
      onClick: onOk
    }]
  }, restConfig);
}
var dialogId = 'ARCO_DIALOG';
export function alert(Component, normalize) {
  return getOpenMethod(Component, dialogId, normalize || normalizeAlert);
}
export function confirm(Component, normalize) {
  return getOpenMethod(Component, dialogId, normalize || normalizeConfirm);
}
export function open(Component) {
  return maskingOpen(Component, dialogId);
}